module.exports = __webpack_public_path__ + "img/img4.49d0a445.png";